import { localizeWithPath } from 'vscode/vscode/vs/nls';

const _moduleId = 'vs/workbench/browser/web.main';
const rendererLogLabel = ( localizeWithPath(_moduleId, 0, 'Window'));

export { rendererLogLabel };
